import React, {useEffect, useState} from "react";
import {Navigate, Outlet, useNavigate} from "react-router-dom";
import {useAppSelector} from "redux/hooks";
import {RootState} from "redux/store";
import {useDispatch} from "react-redux";
import {login, logout} from "redux/reducer/auth";
import {checkTokenValidity, handleLogin} from "helper/auth";
import {data} from "data/env";
import {sso} from "helper/sso";

import Login from "pages/Login/Login";
const _sso = new sso({
  realmUrl: data.sso_url,
  clientId: data.sso_clientid,
  callbackUrl: data.client_callback_url,
  logoutCallbackUrl: data.client_logout_url,
});
const PrivateOutlet = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  if (token) {
    handleLogin(token, dispatch);
  } else {
    navigate("/login");
  }

  const auth = useAppSelector((state: RootState) => state.auth.isAuthenticated);

  return auth ? <Outlet /> : <Login></Login>;
};
export default PrivateOutlet;
